import { createAction } from 'redux-actions';

export const getTransactionTaskAction = createAction('REQUEST/GET_TRANSACTION_TASK');
export const resetTransactionTaskAction = createAction('RESET_TRANSACTION_TASK');
export const resetTransactionTasksAction = createAction('RESET_TRANSACTION_TASKS');
export const resetTransactionTasksAggregateAction = createAction(
  'RESET_TRANSACTION_AGGREGATE_TASKS',
);
export const getTaskCategoriesAction = createAction('GET_TASK_CATEGORIES');
export const setTaskFiltersAppliedAction = createAction('SET_TASK_FILTERS_APPLIED');
